import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { UserLiteData } from '../../../api/ApiTypes';
import { TaskData } from '../../../api/endpoints/tasks';
import { Colors } from '../../../ui';
import { SelectUserTableButton } from '../../common/SelectUserTableButton';
import { Flexer } from '../elements/LayoutElements';
import { useOnPatchTask } from './TaskActions';

const Frame = styled.div<{ active: boolean, done: boolean }>`
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
    padding: .1875rem .375rem .1875rem .1875rem;
    border-radius: 50rem;
    border: solid .0625rem transparent;
    user-select: none;

    &:hover {
        border: solid .0625rem ${Colors.textLightest};
        opacity: 1 !important;
    }
    &:active {
        border: solid .0625rem ${Colors.textLighter};
        opacity: 1 !important;
    }
    ${p => p.active && css`
        border: solid .0625rem ${Colors.textLighter} !important;
        opacity: 1 !important;
    `}

    ${p => p.done && css`
        opacity: .5;
    `}
`;

export const TaskOwnerCell = ({ readonly, task }: { readonly?: boolean, task: TaskData }) => {
    const { user } = (task);

    const onPatchTask = useOnPatchTask(task.id);
    const [open, setOpen] = useState(false);

    const onSelect = (next: UserLiteData) => {
        onPatchTask({ userId: next.id });
        setOpen(false);
    };

    return <Flexer style={{ fontSize: '.9375rem' }}>
        <SelectUserTableButton disabled={readonly} placeholder="Unassigned" value={user} onChange={onSelect} />
    </Flexer>;

};
